import GitHub from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import {about} from "../../components/portfolio"
import './About.css'

const About = () => {
  const {photo,name, role, description, resume, social } = about

  return (
    <div className='about center' id="about">
      
      {photo && (
       <img height="200px" className="mainImg" alt="Avatar placeholder" src={photo} />
      )}
      {/* <h2 className='section__title'>About</h2> */}
      {/* {name && (
        <h2>
          Hi, I am <span className='about__name'>{name}.</span>
        </h2>
      )} */}

      {role && <h3 className='about__role'>{role}.</h3>}
      <p className='about__desc' style={{textShadow: "0.8px 0.8px", fontStyle: "italic"}}>{description && description}</p>

      <div className='about__contact center'>
        {resume && (
          <a href={resume} target="_blank">
            <span type='button' className='btn btn--outline'>
              Resume
            </span>
          </a>
        )}

        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                aria-label='github'
                className='link link--icon'
                target="_blank"
              >
                <GitHub />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label='linkedin'
                className='link link--icon'
                target="_blank"
              >
                <LinkedInIcon />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default About
